import script from "./PersonPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./PersonPage.vue?vue&type=script&setup=true&lang=ts"

import "./PersonPage.vue?vue&type=style&index=0&id=3a1408b2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a1408b2"]])

export default __exports__